import React, { useState, useContext, useRef } from "react";
import { AppBar, Avatar, Icon, styled, Toolbar, Box, Typography } from '@mui/material';
import logo from './static/media/biorad_logo.ff18f5f6.svg';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import Grow from '@mui/material/Grow';
import Paper from '@mui/material/Paper';
import Popper from '@mui/material/Popper';
import MenuItem from '@mui/material/MenuItem';
import MenuList from '@mui/material/MenuList';
import { AccountContext } from "./components/login/Account";
import { useNavigate, Navigate } from 'react-router-dom';
import Pool from "./components/UserPool";

const StyledToolbar = styled(Toolbar)({
  display: "flex",
  flex: 1,
  justifyContent: 'space-between',
});

const Icons = styled(Icon)({
  alignItems: "center",
  display: 'flex',
  flex: 1,
  gap: '15px',
  justifyContent: 'flex-end'

})


const Navbar = () => {
  const [status, setStatus] = useState(false);
  const [profile, setProfile] = useState(null);
  const { getSession, logout } = useContext(AccountContext);
  let navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const anchorRef = useRef(null);
  const [companyName, setCompanyName] = useState('')
  var storedValue = sessionStorage.getItem('clickedInstrument')
  // console.log("Mphasis",storedValue)
  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event) => {
    if (
      anchorRef.current &&
      anchorRef.current.contains(event.target)
    ) {
      return;
    }
    setOpen(false);
  };

  function handleListKeyDown(event) {
    if (event.key === 'Tab') {
      event.preventDefault();
      setOpen(false);
    } else if (event.key === 'Escape') {
      setOpen(false);
    }
  }

  // return focus to the button when we transitioned from !open -> open
  const prevOpen = React.useRef(open);

  React.useEffect(() => {
    // if (prevOpen.current === true && open === false) {
    //   anchorRef.current!.focus();
    // }
    getSession().then(session => {
      // console.log("Session", session)
      if(session)
      {
        setProfile(session);
        sessionStorage.setItem("userProfile", JSON.stringify(session.idToken.payload));
        sessionStorage.setItem("customerID", JSON.stringify(session.user))
        sessionStorage.setItem("idToken", JSON.stringify(session.idToken));
        setStatus(true);
        sessionStorage.setItem("isAuth", true)
        setCompanyName(session.idToken.payload.nickname)
      }
      else {
        redirectToLogin();
      }
      
    });

    if (!status) {
      redirectToLogin();
    }

    prevOpen.current = open;
  }, [open]);
  const redirectToLogin = () => {
    const user = Pool.getCurrentUser();
    if (!user) {
      navigate("/login");
    }
  };
  return (
    <AppBar position='sticky' sx={{ background: 'white', height: 76, display: 'flex', borderBottom: '4px solid #00a650' }}>
      <StyledToolbar>
        <a href="./products" >
          <img style={{ height: 30 }} src={logo} alt="logo" title="Products" />
        </a>
        <Icons style={{ height: 40 }}>
          <div>
            <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', marginLeft: '2', }}>
              <Typography fontWeight={500} fontSize={20} color="text.secondary" style={{ marginRight: 5 }}>Welcome to </Typography>
              <Typography fontWeight={500} fontSize={20} style={{ color: '#00a650' }} textAlign={"center"}>Data Management System -  {storedValue}</Typography>
            </Box>
          </div>
          <div>

            <Avatar
              ref={anchorRef}
              id="composition-button"
              aria-controls={open ? 'composition-menu' : undefined}
              aria-expanded={open ? 'true' : undefined}
              aria-haspopup="true"

              onClick={handleToggle} src="" />
            <Popper
              open={open}
              anchorEl={anchorRef.current}
              role={undefined}
              placement="bottom-start"
              transition
              disablePortal
            >
              {({ TransitionProps, placement }) => (
                <Grow
                  {...TransitionProps}
                  style={{
                    transformOrigin:
                      placement === 'bottom-start' ? 'left top' : 'left bottom',
                  }}
                >
                  <Paper>
                    <ClickAwayListener onClickAway={handleClose}>
                      <MenuList
                        autoFocusItem={open}
                        id="composition-menu"
                        aria-labelledby="composition-button"
                        onKeyDown={handleListKeyDown}
                      >
                        <MenuItem >{profile.idToken && profile.idToken.payload && profile.idToken.payload.given_name ? profile.idToken.payload.given_name : profile.idToken.payload.email}</MenuItem>
                        {/* <MenuItem onClick={handleClose}>My account</MenuItem> */}
                        <MenuItem onClick={logout}>Logout</MenuItem>
                      </MenuList>
                    </ClickAwayListener>
                  </Paper>
                </Grow>
              )}
            </Popper>
          </div>

        </Icons>
      </StyledToolbar>
    </AppBar>
  )
}

export default Navbar;